import _ from "lodash";

const isChartValid = (chartConfig) => {
  if (!chartConfig?.Name) {
    return false;
  } else if (
    chartConfig?.AnalyticType === false ||
    chartConfig?.AnalyticType === null ||
    chartConfig?.AnalyticType === undefined ||
    chartConfig?.AnalyticType === "UNK"
  ) {
    return false;
  } else if (
    chartConfig?.useSpecificDates &&
    (!chartConfig?.BeginDate || !chartConfig?.EndDate)
  ) {
    return false;
  } else return true;
};

const orderCharts = (gridData, charts) => {
  let reOrderedCharts = [];
  for (let row = 0; row < gridData.length; row++) {
    for (let col = 0; col < 3; col++) {
      const chart = _.find(charts, (x) => x.Id === gridData[row][col]);
      if (
        chart &&
        !_.find(reOrderedCharts, (x) => x.Id === gridData[row][col])
      ) {
        reOrderedCharts.push(chart);
      }
    }
  }

  return reOrderedCharts;
};

export { isChartValid, orderCharts };
